module.exports = __webpack_public_path__ + "assets/img/thumb-Ultimate-Ears-Social-Static-Ad.b789d521.webp";